var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataAdded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9241 14.3456C28.8824 22.0775 22.5807 28.3799 14.8489 28.4223C7.11699 28.4648 0.882859 22.2313 0.924537 14.4994C0.966214 6.76756 7.26792 0.465205 14.9998 0.422735C22.7317 0.380264 28.9658 6.61376 28.9241 14.3456ZM2.32452 14.4917C2.28701 21.4504 7.89773 27.0606 14.8564 27.0223C21.8151 26.9841 27.4866 21.312 27.5241 14.3533C27.5616 7.39464 21.9509 1.78449 14.9922 1.82271C8.03356 1.86094 2.36203 7.53305 2.32452 14.4917Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32941 3.50778C3.71746 5.56814 1.92456 8.49129 1.27199 11.7534C0.619416 15.0156 1.14982 18.4035 2.76816 21.3101C4.38651 24.2167 6.98701 26.452 10.1037 27.6155C13.2204 28.779 16.6495 28.7946 19.7767 27.6596C22.9038 26.5245 25.5246 24.313 27.1693 21.4212C28.814 18.5295 29.3753 15.1465 28.7525 11.8786C28.1296 8.61063 26.3634 5.67127 23.7703 3.58721C21.1773 1.50314 17.9268 0.410584 14.6014 0.50531L15 14.4996L6.32941 3.50778Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAdded);
export default __webpack_public_path__ + "static/media/DATA_ADDED.4fd4836c81d2f87f685c27e585a60808.svg";
export { ForwardRef as ReactComponent };